import { styled } from '@mui/material/styles';

const StyledLabelTag = styled('div')(
  ({ theme, isLabel }) => `
   background-color: ${isLabel ? `${theme.DS_palette.label.bgColor}` : `${theme.DS_palette.tag.bgColor}`};
   padding:  ${theme.DS_spacing(['xxs'])} 12px;
   width: fit-content;
   border-radius: ${theme.DS_border.radius.labelsTags};
   color: ${isLabel ? `${theme.DS_palette.label.text} !important` : `${theme.DS_palette.tag.text} !important`};
   margin: ${theme.DS_spacing(['xxs'])} 0;
   text-transform: uppercase;
   display: flex;
   justify-content: center;
   align-items: center;

   svg {
     fill: none;
     font-size: ${theme.DS_spacing(['sm'])};
   }
 
    ${theme.breakpoints.up('lg')} {
    padding:${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['md'])} ;
    }
   
  
  `,
);

export { StyledLabelTag };
